import { PlainDateType } from './dateTypes';
import { Deductions } from './deductions';
import { ExpensesRates } from './expensesRates';
import { z } from 'zod';

export type Expenses = z.infer<typeof Expenses>;
export const Expenses = z.object({
    date: PlainDateType,
    countryCode: z.string(),
    city: z.string().nullish(),
    rates: ExpensesRates.nullish(),
    deductions: Deductions.nullish(),

    breakfast: z.boolean(),
    lunch: z.boolean(),
    dinner: z.boolean(),
    overnight: z.boolean(),

    perDiem: z.number(),
    deducted: z.number(),
    perDiemTotal: z.number(),
    overnightTotal: z.number(),
    sum: z.number(),
    error: z.enum(['missingRates', 'missingDeductions']).nullish(),
});
